<div mat-dialog-content>
  <div class="flex flex-col">

    <div class="flex flex-col md:flex-row md:gap-4" *ngIf="changes.length === 0 && change.id === 0">
      <button mat-raised-button color="primary" (click)="createChange()">
        Change Name
      </button>
    </div>

    <div class="flex flex-col gap-4" *ngIf="change.id > 0">
      <form [formGroup]="changeForm" (ngSubmit)="submitChange()">
        <span class="font-semibold text-lg">Request Name Change</span>
        <div class="flex flex-col md:flex-row md:gap-4">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="firstName" required>
            <mat-error *ngIf="changeForm.get('firstName')?.hasError('required')">First Name is required</mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Middle Name</mat-label>
            <input matInput formControlName="middleName">
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="lastName" required>
            <mat-error *ngIf="changeForm.get('lastName')?.hasError('required')">Last Name is required</mat-error>
          </mat-form-field>
        </div>
      </form>

      <span>You must upload current identification, or proof of legal change of name.</span>
      <document [entityId]="change.id"
                [entityType]="sharedService.hemoTechChange"
                [types]="documentTypes"
                [editable]="true"></document>

      <div class="flex flex-col md:flex-row pt-4 md:gap-4">
        <button mat-raised-button color="primary" type="button" (click)="submitChange()" [disabled]="changeForm.invalid">
          Submit Change
        </button>
        <button mat-button color="warn" type="button" (click)="cancel()">
          Cancel Request
        </button>
      </div>
    </div>

    <div class="flex flex-col gap-4 pt-4" *ngIf="changes.length > 0">
      <span class="font-semibold text-lg">Change History</span>
      <mat-table [dataSource]="changeSource" aria-label="change requests" class="portal-table">
        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef>New Name</mat-header-cell>
          <mat-cell *matCellDef="let change">
            <span class="mobile-label">New</span>
            {{ change.firstName }} {{ change.middleName }} {{ change.lastName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="originalValue">
          <mat-header-cell *matHeaderCellDef>Current Name</mat-header-cell>
          <mat-cell *matCellDef="let change">
            <span class="mobile-label">Current</span>
            {{ change.originalValue }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="approved">
          <mat-header-cell *matHeaderCellDef>Approved</mat-header-cell>
          <mat-cell *matCellDef="let change">
            <span class="mobile-label">Approved</span>
            {{ change.approved? 'Yes' : 'No' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="completed">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let change">
            <span class="mobile-label">Status</span>
            {{ change.completed? 'Completed' : 'Pending' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let change">
            <span class="mobile-label">Actions</span>
            <button mat-button color="warn" (click)="deleteChange(change.id)" [disabled]="change.completed">
              Cancel Request
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="changeColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: changeColumns"
                class="portal-interactive-row"
                [ngClass]="row.archived? 'portal-archived' : ''"></mat-row>
      </mat-table>
      <div class="flex flex-row">
        <button mat-button class="ml-auto" color="warn" (click)="cancel()">Close</button>
      </div>
    </div>
  </div>
</div>
